import styled from "styled-components";
import { Docs, Download } from "../icons";
import { Label } from ".";

const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #5e514d;
  margin-top: 16px;
`;

const TitleOne = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #5e514d;
  margin-top: 16px;
`;

const Button = styled.button`
  background: transparent;
  border: none;
  color: #f2a900;

  &:hover {
    opacity: 0.8;
  }
`;

const Body = styled.div`
  padding: 1em;
  background: #fff;
`;

const Footer = styled.div`
  background: #fafafa;
  padding: 1em;
`;

const Container = styled.div`
  width: 100%;
  align-items: center;
  overflow: hidden;
  border: #e8e8e8 thin solid;
  border-radius: 0.5em;

  &:hover {
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    transition: box-shadow 0.3s ease-in-out;
  }
`;

const LinkDocument = (props) => {
  return (
    <Container className="text-start">
      <Body>
        <div className="d-flex bd-highlight align-items-center w-100">
          <div className="d-flex text-start w-100 bd-highlight">
            <Label>{props.label}</Label>
          </div>
          <div className="flex-shrink-1 bd-highlight">
            {props.labelIconFalse ? (
              ""
            ) : props.labelIcon ? (
              <props.labelIcon fill="#DADADA" />
            ) : (
              <Docs fill="#DADADA" />
            )}
          </div>
        </div>
        {props.rowLine ? <TitleOne>{props.title}</TitleOne> : <Title>{props.title}</Title>}
      </Body>
      <Footer
        className="d-flex bd-highlight align-items-center w-100 pt-2"
        style={{ borderTop: "#EDEEEE thin solid" }}
      >
        <div className="d-flex text-start w-100 bd-highlight">
          <a href={props.linkRedirect} target="blank">
            <Button>{props.linkLabel ? props.linkLabel : "Download"}</Button>
          </a>
        </div>
        <div className="flex-shrink-1 bd-highlight">
          {props.linkIcon ? (
            <props.linkIcon fill="#f2a900" />
          ) : (
            <Download fill="#f2a900" />
          )}
        </div>
      </Footer>
    </Container>
  );
};

export default LinkDocument;
